import { SITE_EMAIL } from '@/data/links'

const ENDPOINT = import.meta.env.VITE_CONTACT_ENDPOINT

/**
 * Send a demo request. Posts the form to VITE_CONTACT_ENDPOINT when one is
 * set; otherwise opens the visitor's mail app with the request filled in, so a
 * request is never silently dropped.
 *
 * @param {FormData} data
 * @param {string} subject  Used for the mail-app fallback.
 * @returns {Promise<'posted' | 'mailed'>}
 */
export async function sendInquiry(data, subject) {
  if (!ENDPOINT) {
    const body = [...data].map(([key, value]) => `${key}: ${value}`).join('\n')

    window.location.href = `mailto:${SITE_EMAIL}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`
    return 'mailed'
  }

  const response = await fetch(ENDPOINT, {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: data,
  })
  if (!response.ok) throw new Error(`Contact endpoint answered ${response.status}`)
  return 'posted'
}
